import { useEffect, useState } from "react";
import SiteNav from "@/pages/home/components/SiteNav";
import Hero from "@/pages/home/components/Hero";
import LatestGallery from "@/pages/home/components/LatestGallery";
import Collections from "@/pages/home/components/Collections";
import Models from "@/pages/home/components/Models";
import Archive from "@/pages/home/components/Archive";
import BehindScenes from "@/pages/home/components/BehindScenes";
import Guide from "@/pages/home/components/Guide";
import Faq from "@/pages/home/components/Faq";
import Subscribe from "@/pages/home/components/Subscribe";
import SiteFooter from "@/pages/home/components/SiteFooter";

function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > 600);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  if (!visible) return null;

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: "smooth" })}
      aria-label="返回顶部"
      className="fixed bottom-6 right-6 z-40 flex h-11 w-11 items-center justify-center rounded-full bg-primary-500 text-background-50 transition-colors hover:bg-primary-600"
    >
      <i className="ri-arrow-up-line text-xl" />
    </button>
  );
}

export default function Home() {
  return (
    <div className="min-h-screen bg-background-50 font-body">
      <SiteNav />
      <main>
        <Hero />
        <LatestGallery />
        <Collections />
        <Models />
        <Archive />
        <BehindScenes />
        <Guide />
        <Faq />
        <Subscribe />
      </main>
      <SiteFooter />
      <BackToTop />
    </div>
  );
}